import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SubAdminGuard({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: 'var(--text3)' }}>Loading…</div>;
  if (!user) return <Navigate to="/join" replace />;
  if (user.isAdmin) return children;
  if (!user.isSubAdmin || user.adminRole !== role) return <Navigate to="/" replace />;
  return children;
}
